<script>
import {attachment as columns} from '../../tables'

export default {
  props: {
    path: {
      type: String,
      default: ''
    },
    billerHash: {
      type: String,
      default: ''
    },
    billerName: {
      type: String,
      default: ''
    },
    filterForm: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('hyperion.attachment')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    }
  },
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      items: {},
      loading: false,
      expand: false,
      filters: {
        q: null,
        page: 1,
        date: []
      }
    }
  },

  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)

    this.getItems()
  },

  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1,
        date: []
      }
    },

    getItems() {
      this.loading = true

      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    sendFtp(attachment) {
      this.loading = true

      this.$http.post(this.routeUri('hyperion.biller.attachment.send.ftp', {biller_hash: this.billerHash}), {
        id: attachment.id,
        biller: this.billerName
      })
      .then((response) => this.handleSuccessResponse(response.data))
      .catch((error) => this.handleXhrError(error))
      .finally(() => this.loading = false)
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Success!',
        description: 'Data has been successfully sended!'
      })
      setTimeout(() => window.location.reload, 2000)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <template v-if="filterForm">
      <a-form layout="inline" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input placeholder="Keyword.." v-model="filters.q" size="small">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" size="small"/>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" html-type="submit" icon="filter" size="small">Filter</a-button>
        </a-form-item>

        <a-form-item>
          <a-button type="dashed" html-type="reset" icon="reload" size="small" @click="handleReset">Reset</a-button>
        </a-form-item>
      </a-form>

      <a-divider dashed/>
    </template>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="this.items.data" rowKey="id"
               :pagination="{ current: items.current_page, total: items.total}" @change="tableChanged">
        <h5 slot="datetime" slot-scope="datetime" class="text-center">
          {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <div slot="file" slot-scope="record">
          <h4>{{ record.title }}</h4>
          <p class="text-sm">{{ record.description }}</p>
          <span class="text-sm text-muted">
              <a-icon type="paper-clip" /> <code>{{ record.filename }}</code>
          </span>
        </div>

        <p class="text-center" slot="mime" slot-scope="mime">
          <strong><code>{{ mime }}</code></strong>
        </p>

        <div slot="action" slot-scope="record" class="text-right">
          <a-tooltip title="Send FTP" v-if="billerName == 'syb'">
            <a-button type="dashed" size="small" icon="cloud-server" @click="sendFtp(record)"/>
          </a-tooltip>
          <a-tooltip title="Send FTP" v-if="billerName == 'finnet'">
            <a-button type="dashed" size="small" icon="cloud-server" @click="sendFtp(record)"/>
          </a-tooltip>
          <a-tooltip title="Download">
            <a-button type="primary" size="small" icon="download" :href="record.url" target="_blank"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
